import React from 'react'
import "./Send_Btn.css";

const Send_Btn = ({
    text = "Send Message",
    onClick,
    type = "button"
}) => {
    return (
        <button
            type={type}
            className={`send_button`}
            onClick={onClick}
        >
            {text}
        </button>
    );
};

export default Send_Btn